// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
// import File from "@insite/mobius/Icons/File"; // Foundation
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code */
import translate from "@insite/client-framework/Translate";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code */

// Foundation --->
import { DocumentModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";
import useParentProductState from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useParentProductState";
import { documentsListStyles } from "@store/Themes/common/props/document";
// <--- Foundation

type OwnProps = WidgetProps & HasProduct;

export interface ProductDetailsDocumentsStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    documentGridItem?: GridItemProps;
    documentLink?: LinkPresentationProps;
    documentIcon?: IconProps;
    documentNameText?: TypographyPresentationProps;
    // Starter Custom Code
    noResult?: TypographyPresentationProps;
    list?: TypographyPresentationProps;
    listItem?: TypographyPresentationProps;
}

export const documentsStyles: ProductDetailsDocumentsStyles = {
    // Foundation --->
    wrapper: documentsListStyles.wrapper,
    container: documentsListStyles.container,
    documentGridItem: documentsListStyles.documentGridItem,
    documentLink: documentsListStyles.documentLink,
    documentIcon: documentsListStyles.documentIcon,
    documentNameText: documentsListStyles.documentNameText,
    // <--- Foundation
};

const styles = documentsStyles;

const ProductDetailsDocuments: React.FC<OwnProps> = ({ product: { documents } }) => {
    // Foundation --->
    const parentProductState = useParentProductState();

    documents = documents?.filter(x => x.documentType !== constants.documentTypes.videos);
    const parentDocuments = parentProductState?.documents?.filter(
        x => x.documentType !== constants.documentTypes.videos,
    );

    if (
        !documents ||
        (documents.length === 0 && !parentProductState?.documents) ||
        parentProductState?.documents?.length === 0 /* Starter Custom Code */
    ) {
        return <>{translate("No Document Available")}</>; // Starter Custom Code
    }
    // <--- Foundation

    // Foundation --->
    const displayDocument = (document: DocumentModel) => {
        if (document.documentType !== constants.documentTypes.videos) {
            return (
                <GridItem key={document.id.toString()} {...styles.documentGridItem}>
                    <Link
                        href={document.filePath}
                        target="_new"
                        {...styles.documentLink}
                        data-test-selector={`productDetails_${document.id}`}
                    >
                        <IconMemo {...styles.documentIcon} />
                        <Typography {...styles.documentNameText}>{document.name}</Typography>
                    </Link>
                </GridItem>
            );
        }
    };
    // <--- Foundation

    return (
        <StyledWrapper {...styles.wrapper}>
            <GridContainer {...styles.container}>
                {/* Foundation ---> */}
                {documents.length
                    ? documents.map(document => displayDocument(document))
                    : parentDocuments?.map(document => displayDocument(document))}
                {/* <--- Foundation */}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDocuments),
    definition: {
        displayName: "Documents",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
